"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var styles_1 = require("./styles");
var Title = styled_1.default.h4(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  ", "\n"], ["\n  ",
    "\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", "px;\n    font-weight: 400;\n  "], ["\n    font-family: ", ";\n    font-size: ", "px;\n    font-weight: 400;\n  "])), theme.typography.main, theme.typography.sizes.title);
}, styles_1.baseStyle);
exports.default = Title;
var templateObject_1, templateObject_2;
